import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";
import {ContractTypes} from "../../types/contract.types";
import {AuthService} from "../../_services/auth.service";
import {environment} from "../../../environments/environment";
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  @Input() isNavbar: boolean;
  @Output() toggleNavbar = new EventEmitter();
  @Output() closeNavbar = new EventEmitter();
  public unreadCount = {
    party: 0,
    initiator: 0,
    personalData: 0,
  };
  public types = ContractTypes;
  // Учредительные документы — пока только на тесте (флаг debugPanel в
  // environment*.ts); на проде пункта в меню нет.
  public readonly canConstituentDocuments = !!environment.debugPanel;

  active = 0;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public translate: TranslateService,
    public authService: AuthService,
    ) { }

  ngOnInit() {
    this.updateActiveState();

    // Подписываемся на изменения query параметров
    this.route.queryParams.subscribe(() => {
      this.updateActiveState();
    });

    // Подписываемся на изменения маршрута
    this.router.events.subscribe(() => {
      this.updateActiveState();
    });
  }

  updateActiveState() {
    if(this.isMyContracts()){
      this.active = 1;
    }
    else if(this.isContractsForMe()){
      this.active = 2;
    }
    else if(this.isConstituentDocuments()){
      this.active = 4;
    }
    else if(this.isRequest()){
      this.active = 5;
    }
  }

  isMyContracts(){
    const url = this.router.url;
    const queryParams = this.route.snapshot.queryParams;
    
    // Если на странице /contracts (но не /contracts/create, /contracts/read и т.д.)
    if (url.includes('/contracts') && !url.includes('/contracts/')) {
      // Если нет query параметра party или он равен false - это Outbox
      return !queryParams.party || queryParams.party === 'false' || queryParams.party === false;
    }
    
    // Для других случаев проверяем наличие party=false в URL
    return url.includes('party=false');
  }
  isContractsForMe(){
    return this.router.url.includes('party=true');
  }
  isConstituentDocuments(){
    return this.router.url.includes('constituent-documents');
  }
  isRequest(){
    return this.router.url.includes('request');
  }
  isLanding() {
    return this.router.url.includes('landing');
  }
  isSidebarShow(){
    return (this.router.url.includes('contract') || this.router.url.includes('constituent-documents')) && !this.router.url.includes('read') && (!this.router.url.includes('create') || this.isConstituentDocuments()) && !this.router.url.includes('pdf-generate');
  }
  isNewRoute(party: boolean = false, request: boolean = false, constituent: boolean = false){
    if(party){
      this.active = 2;
    } else if(request){
      this.active = 5;
    } else if(constituent){
      this.active = 4;
    } else {
      this.active = 1;
    }
    this.closeNavbar.emit();
  }
  logout() {
    this.authService.logout(true);
    this.toggleNavbar.emit();
  }
  close(){
    this.active = 0;
    this.closeNavbar.emit();

  }
}
